export type MaybeNumber = number | null | undefined

export function centsToDollarsDisplay(value: MaybeNumber) {
    if (typeof value === "undefined" || value === null || isNaN(value))
        return null;
    return `${value < 0 ? '-' : ''}$${(Math.round(Math.abs(value)) * 0.01).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
}

export function centsToDollarsCompact(value: MaybeNumber) {
    if (typeof value === "undefined" || value === null || isNaN(value)) {
        return null;
    }
    const dollars = Math.abs(value) / 100
    const sign = value < 0 ? '-' : ''
    if (dollars >= 1_000_000) { return `${sign}$${(dollars / 1_000_000).toFixed(1)}M` }
    if (dollars >= 1_000) { return `${sign}$${(dollars / 1_000).toFixed(1)}k` }
    return `${sign}$${dollars.toFixed(0)}`
}

export function percentageDisplay(value: MaybeNumber | string) { // ""
    if (typeof value === "undefined" || value === null || (typeof value === 'number' && isNaN(value)) || (typeof value === "string" && value === ""))
        return null;
    if(typeof value === "string")
        return `${parseFloat(value).toFixed(2)}%`

    return `${value.toFixed(2)}%`
}

export function percentageDisplayWhole(value: MaybeNumber) {
    if (typeof value === "undefined" || value === null || isNaN(value))
        return null;
    return `${Math.round(value*100)}%`
}

export function integerDisplay(value: MaybeNumber) {
    if (typeof value === "undefined" || value === null || isNaN(value))
        return 0;
    return `${value.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})}`;
}

export function camelCaseToWords(value: string | null | undefined) {
     if (typeof value === "undefined" || value === null)
        return ""

    return value
        .replace(/([A-Z])/g, ' $1')    // insert a space before all caps
        .replace(/^./, function(str){ return str.toUpperCase(); })     // uppercase the first character
}

export function camelize(str: string) {
    str = str.trim()

    const word = str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');

    return word
  }
